import {doStyleProductFlags, doStyleProductsListing} from "../blocks/productsListing";
import {doStyleAdvantages} from "../blocks/advantages";
import {TranslationsManager} from "../utils/localisationManager";

export class MainPage {
    static async doInit() {
        doStyleProductsListing();
        MainPage.doStyleMisc();
        doStyleAdvantages();
        MainPage.doSetupBlogEntries();
        doStyleProductFlags();
        MainPage.doStyleFooterBanners();
        MainPage.doStyleCarouselWithNav();
        MainPage.doStyleProductSlider();
        return true;
    }

    static doStyleMisc() {
        $('.welcome-wrapper .stores-header li').on('click', function (ev){
            const id = $(ev.currentTarget).attr('data-id');
            const activeId = $('.welcome-wrapper .stores-header li.active');
            if(activeId.attr('data-id') !== id) {
                activeId.removeClass('active')
                $(ev.currentTarget).addClass('active')
                $('.welcome-wrapper .stores .store').removeClass('active');
                $(`.welcome-wrapper .stores .store#${id}`).addClass('active');
            }
        })
    }
    static async doSetupBlogEntries() {
        // blog grid homepage
        $(".news-item").addClass("col-sm-12 col-md-12 col-lg-6");
        $(`
            <div class="blog-hp container">
                <div class="blog-title"><div class="page-title-separator"></div><h1>UTOPY BLOG</h1></div>
                <div class="entries"></div>
                <div class="more-btn"></div>
            </div>
        `).insertAfter(".footer-banners");

        if($('html[lang="cs"]').length) {
            try {
                const wpArticles = await (await fetch(`https://blog.utopy.cz/wp-json/wp/v2/posts?_embed`)).json();

                for (let i = 0; i < Math.min(wpArticles.length, 3); i++) {
                    const date = wpArticles[i].date;
                    let formatedDate = date.replace('T', '-').split('-');
                    formatedDate = formatedDate[2] + '.' + formatedDate[1] + '.' + formatedDate[0];


                    $(`
                        <div class="news-item">
                            <div class="image">
                                <a href="${wpArticles[i].link}" title="UTOPY challenge - co nového jsme si pro tebe připravili?">
                                    <img src="${wpArticles[i]._embedded["wp:featuredmedia"][0].source_url}" alt="">
                                </a>
                            </div>
                            <div class="text">
                                <a href="${wpArticles[i].link}" class="title">
                                    ${wpArticles[i].title.rendered}
                                </a>
                                <time datetime="${wpArticles[i].date}">${formatedDate}</time>
                                <div class="description">
                                    ${wpArticles[i].excerpt.rendered}
                                </div>
                                <div class="news-item-btn">
                                    <a href="${wpArticles[i].link}"></a>
                                </div>
                            </div>
                        </div>
                    `).appendTo('.blog-hp .entries')
                }

                $(`<a href="https://blog.utopy.cz/">${TranslationsManager.doGetStringByLang('MORE_BTN')}</a>`).appendTo('.blog-hp .more-btn')
            } catch (e) {
                console.error('Could not fetch WP articles');
                console.error(e);
            }
        } else {
            $(".blog-hp .entries").load("/blog/ .news-wrapper .news-item:nth-child(-n+3)", function() {
                // $('.blog-hp').prepend('<div class="blog-title"><div class="page-title-separator"></div><h1>UTOPY BLOG</h1></div>');
                // $('.news-item .text').appendTo('.blog-hp .image > a');
                $('.news-item .text').append('<div class="news-item-btn"><a href="/"></a></div>');
                $('.blog-hp .news-item').each(function (index, element) {
                    var $link = $(element).find('.text > a').attr('href');
                    $(element).find('.news-item-btn > a').attr('href', $link);
                });
            });

            $(`<a href="/blog">${TranslationsManager.doGetStringByLang('MORE_BTN')}</a>`).appendTo('.blog-hp .more-btn')
        }
    }
    static doStyleFooterBanners() {
        const $reviews = $(`
            <div class="content-wrapper container reviews-wrapper-wrapper">
                <div class="content-wrapper-in">
                    <div class="content">
                        <h1>${TranslationsManager.doGetStringByLang('CUSTOMER_REVIEWS_HEADER')}</h1>
                        <div class="reviews-wrapper"></div>
                    </div>
                </div>
            </div>
        `);

        if($('#dklab_instagram_widget').length > 0) {
            $reviews.insertBefore('#dklab_instagram_widget');
        } else {
            $reviews.insertBefore('#footer');
        }
        // reviews
        $('.banner-wrapper img[alt="recenze"]').each(function (index, element) {
            $(element).closest('.banner').parent().removeClass('hidden').addClass('review-item').appendTo('.reviews-wrapper');
        })
    }
    static doStyleCarouselWithNav() {
        let $currentlySelectedIndex = 0;
        // add carousel navigation
        $(`<div id="carousel-navigation"></div>`).insertAfter('.wide-carousel .carousel-inner');

        let item = $('.wide-carousel #carousel > .carousel-inner > .item');
        for( let i=0; i < item.length; i++ ) {
            $(item[i]).addClass(`item${i}`);
            $(`
                    <a class="nav-item item${i} carousel" href="#carousel" role="button" data-slide-to="${i}"></a>
                `).appendTo('#carousel-navigation');
        }

        $(item)
            .observe({ attributes: true, attributeFilter: ['class'] },  function(record) {
                if(record.target.classList.contains('active') && !record.target.classList.contains('left')) {
                    var currentItemNo = record.target.className.match(/[0-9]+/g);

                    // Prevent already selected items from being reselected
                    if(currentItemNo[0] === $currentlySelectedIndex) { return; }

                    var prevSelector = `.nav-item.item${$currentlySelectedIndex}`;
                    var currentSelector = `.nav-item.item${currentItemNo[0]}`
                    // Cleanup previous selection

                    $(prevSelector).removeClass('active');
                    $currentlySelectedIndex = currentItemNo[0];
                    $(currentSelector).addClass('active');
                }
            });
    }
    static doStyleProductSlider() {
        const header = $('[class*="homepage-products-heading-"]');
        if (header.length) {
            header.each(function (index, element) {
                $(element).wrap(`<div class='glider-contain i-${index}'></div>`);
                $(`.glider-contain.i-${index} + .products-block`).appendTo(`.glider-contain.i-${index}`)

                $(`.glider-contain.i-${index}`).append(`
                    <div data-glide-el="controls">
                        <button aria-label="Previous" class="glider-prev"></button>
                        <button aria-label="Next" class="glider-next"></button>
                    </div>`)

                new Glider(document.querySelector(`.glider-contain.i-${index} .products-block`), {
                    // type: 'carousel',
                    draggable: true,
                    slidesToShow: 1.2,
                    dragVelocity: 1,
                    // dots: '.dots',
                    arrows: {
                        prev: `.glider-contain.i-${index} .glider-prev`,
                        next: `.glider-contain.i-${index} .glider-next`,
                    },
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                });
            })
        }
    }
}
